import './App.css';
import { Box, Container, CssBaseline, Typography, IconButton, useMediaQuery, createTheme, ThemeProvider, Button, Paper } from '@mui/material';
import { Parallax, ParallaxProvider, useParallax } from 'react-scroll-parallax';
import React, { useEffect, useRef, useState } from 'react';
import PageHead from './PageHead';
import PageList from './PageList';
import { BrowserRouter } from 'react-router-dom';


import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';
import { fetchPlatformData } from './Platforms';

function App() {
  document.title = fetchPlatformData("name");
  const { favIcon } = fetchPlatformData("siteImages")

  // Set a variable favicon 
  const link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = favIcon;

  const platformTheme = fetchPlatformData('theme');
  const platformMode = platformTheme.mode;
  const systemMode = useMediaQuery('(prefers-color-scheme: dark)') ? 'dark' : 'light';
  const [currentTheme, setCurrentTheme] = useState({
    colorMode: platformMode ?? systemMode, primary: platformTheme.primary, secondary: platformTheme.secondary, appBar: platformTheme.appBar
  });

  const muiTheme = createTheme({
    palette: {
      mode: currentTheme.colorMode,
      primary: {
        main: currentTheme.primary.main,
      },
      secondary: {
        main: currentTheme.secondary.main,
      },
      raw: currentTheme,
      funct: {
        modeAdjust: (int) => currentTheme.colorMode === 'dark' ? 900 - Math.max(int, 50) : int
      }
    }
  });

  return (
    <React.Fragment>
      <CssBaseline />
      <BrowserRouter>
        <ThemeProvider theme={muiTheme}>
          <Container disableGutters maxWidth={false}>
            <Paper elevation={0}>
              <PageHead />
              <Box style={{ minHeight: "100vh", position: 'relative', background: muiTheme.palette.background.paper }}>
                <PageList />
              </Box>
            </Paper>
          </Container>
        </ThemeProvider>
      </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
